let initialState = {
  isLoggedIn: false, // TEMP-DEBUG: revert before commit
  userType: "",
};

const isLoggedInReducer = (state = initialState, action) => {
  switch (action.type) {
    case "IS_LOGGEDIN":
      return {
        ...state,
        isLoggedIn: action.payload,
      };
    case "SET_USERTYPE":
      return {
        ...state,
        userType: action.payload,
      };
    default:
      return state;
  }
};

export default isLoggedInReducer;
